import apiClient from "@/app/api/client";
import type { JobScheduler, QueueStatus, ScheduledTask } from "../types";

interface SingleResponse<T> {
	success: true;
	data: T;
}

/**
 * ⚠️ `GET /jobs/queues` va `/jobs/schedulers` SAHIFALANMAGAN — konvert
 * `data.items` (massiv), `data.items` + `meta` EMAS. Xato joblar va
 * rejali vazifalar esa sahifalangan va ular `usePaginatedQuery` orqali
 * o'qiladi.
 */
export const jobsApi = {
	async queues(): Promise<QueueStatus[]> {
		const response = await apiClient.get<SingleResponse<{ items: QueueStatus[] }>>("/jobs/queues");

		return response.data.data.items;
	},

	async schedulers(): Promise<JobScheduler[]> {
		const response =
			await apiClient.get<SingleResponse<{ items: JobScheduler[] }>>("/jobs/schedulers");

		return response.data.data.items;
	},

	async retryJob(queue: string, id: string): Promise<void> {
		await apiClient.post(`/jobs/queues/${queue}/jobs/${id}/retry`);
	},

	async retryScheduledTask(id: string): Promise<ScheduledTask> {
		const response = await apiClient.post<SingleResponse<ScheduledTask>>(
			`/jobs/scheduled-tasks/${id}/retry`
		);

		return response.data.data;
	},
};
